import n from "@forge-ui-components/tracing-client";
const l = { moduleName: "AdobeAnalyticsDataEmitter" }, c = (t, o) => {
  const a = new CustomEvent(t, { detail: { ...o } }), e = document.querySelector("html");
  e ? e.dispatchEvent(a) : n.log.error(`Failed to send Beacon request to Adobe Analytics with EventType: ${t}`, l);
};
export {
  c as default
};
//# sourceMappingURL=index.es2.js.map
